var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-orders-page"
  }, [_c('Tab'), _vm.fetching ? _c('p', [_c('Loading')], 1) : _vm.orders.length ? [_c('ul', {
    staticClass: "s-mb-6"
  }, _vm._l(_vm.orders, function (order, i) {
    return _c('li', {
      key: i
    }, [_c('Item', {
      attrs: {
        "data": order,
        "status": _vm.status
      }
    })], 1);
  }), 0), _vm._m(0), _c('Pagination', {
    attrs: {
      "current": _vm.page,
      "last": _vm.lastPage
    }
  })] : _c('div', {
    staticClass: "s-pt-40 s-text-center"
  }, [_c('img', {
    staticClass: "s-mb-3",
    attrs: {
      "src": require("@/assets/images/liff/empty.svg")
    }
  }), _c('p', {
    staticClass: "s-text-gray"
  }, [_vm._v("沒有團購")]), _c('p', {
    staticClass: "s-text-gray"
  }, [_vm._v("訂單小幫手每 3 分鐘會更新一次訂單狀態唷")])])], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-orders-notify s-mb-4"
  }, [_c('p', {
    staticClass: "s-text-gray s-text-sm"
  }, [_vm._v("訂單小幫手每 3 分鐘會更新一次訂單狀態唷")])]);
}]

export { render, staticRenderFns }